import { ReactElement } from 'react';
import DomainSensitiveLink from '../../../../../../common/domain-sensitive-link/domain-sensitive-link';
import LazyLoadedImage from '../../../../../../common/lazy-loaded-image/lazy-loaded-image';
import MaterialClickHandler from '../../../../../../common/material-click-handler/material-click-handler';
import PagesInfo from '../../../../../../common/pages-info/pages-info';
import { CatalogProps } from '../../../../../../utils/enhanced-ecommerce';
import imagePathCreator from '../../../../../../utils/image-path-creator/image-path-creator';
import isInteractiveStandaloneMaterial from '../../../../../../utils/interactive/is-interactive-standalone-material';
import previewHeightCalculator, { BlockType } from '../../../../../../utils/preview/preview-height-calculator';
import './material-image.scss';

type MaterialImageProps = {
    item: Material;
    link: string;
    onClick: VoidFunction;
    imageSize: BlockType;
    index?: number;
    internalPath?: string;
};

const MaterialImage = (props: MaterialImageProps): ReactElement => {
    const { item, link, onClick, imageSize, index, internalPath } = props;

    const isStandalone = isInteractiveStandaloneMaterial(item);
    const { width, height } = previewHeightCalculator(imageSize);

    const imageSource = item.firstPreviewImage?.plain;
    const imageProcessed = imagePathCreator.optimizedImg({ preview: imageSource }, { w: width, h: height, q: 50 });

    const materialProps: CatalogProps = { internalPath, itemIndex: index };

    return (
        <MaterialClickHandler transparent item={item} materialProps={materialProps}>
            <DomainSensitiveLink
                omitForBots
                className='material-image-wrapper'
                href={link}
                title={item.title}
                onClick={onClick}
                style={{ width, height }}
            >
                <LazyLoadedImage src={imageProcessed} alt={item.title} className='material-image' />
                {!isStandalone && <PagesInfo item={item} />}
            </DomainSensitiveLink>
        </MaterialClickHandler>
    );
};

export default MaterialImage;
